import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "src/shared/store";
import isEmpty from "src/shared/util/is-empty";
import { fetchEvents } from "./eventsApi";
import { EventsResponse } from "./model/events";

export interface EventsState {
  data: EventsResponse;
  status: "pending" | "fulfilled" | "rejected";
}

const initialEventData = {
  embed_url: "",
  end_date: "",
  highlighted_product: null,
  name: "",
  start_date: "",
  status: "",
};
const initialState: EventsState = {
  data: initialEventData,
  status: "pending",
};

export const eventsSlice = createSlice({
  name: "events",
  initialState,
  reducers: {
    reset: (state) => {
      state.data = initialEventData;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetch.pending, (state) => {
        state.status = "pending";
      })
      .addCase(fetch.fulfilled, (state, action) => {
        state.status = "fulfilled";
        const { data } = action.payload || {};
        if (!isEmpty(data)) {
          state.data = data;
        }
      })
      .addCase(fetch.rejected, (state, action) => {
        state.status = "rejected";
      });
  },
});

export const { reset } = eventsSlice.actions;

export const fetch = createAsyncThunk("events/fetchEvents", async () => {
  try {
    const response: any = await fetchEvents();
    return response;
  } catch (e) {
    throw e;
  }
});

export const dataSelector = (state: RootState) => state.events.data;
export const statusSelector = (state: RootState) => state.events.status;

export const fetchOptions = {
  fetch,
  dataSelector,
  statusSelector,
};

export default eventsSlice.reducer;
